<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.index,
                    },
                    {
                        name: activity.title,
                        href: meta.links.activity_show,
                    },
                    {
                        name: $tc('messages.questions', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <NavLinks :links="meta.menu.links" />
        <NavLinks :links="meta.links.adaptations" class="mt-1" />
        <div class="mt-1" v-if="meta.links.print">
            <AppButton :href="meta.links.print" element="a"> {{ $t('messages.print') }} </AppButton>
        </div>

        <QuizForm :activity="activity" :questions="questions" :options="options" :meta="meta" />
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import QuizForm from '@/Pages/Teacher/Quiz/Activity/Preview/QuizForm.vue';
import NavLinks from '@/components/NavLinks.vue';
import AppButton from '../../../../../components/AppButton.vue';

export default {
    components: {
        AppButton,
        NavLinks,
        QuizForm,
        PanelPage,
    },
    layout: Layout,
    name: 'Edit',
    props: ['meta', 'options', 'questions', 'activity'],
};
</script>
